export default "__VITE_ASSET__D0fS3XMG__"